import { object, string } from "yup";
import { RECOVERY_CODE_ERROR_MESSAGE, RECOVERY_CODE_LENGTH } from "./constants";

export const recoveryCodeEntryValidationSchema = object({
  recoveryCode: string()
    .required(RECOVERY_CODE_ERROR_MESSAGE)
    .min(RECOVERY_CODE_LENGTH, RECOVERY_CODE_ERROR_MESSAGE)
    .max(RECOVERY_CODE_LENGTH, RECOVERY_CODE_ERROR_MESSAGE),
});
